import { BundleData } from '../types';
import { getStudentBundleSelections } from './getStudentBundleSelections';

export const checkIsBootcampSignup = (bundleData?: BundleData): boolean =>
  !!getStudentBundleSelections(bundleData)[0]?.courseOfferingId;
